export { default } from './getScrollbarSize';